import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import { ButtonBase, FormControl } from '@mui/material';
import errorImage from '../../Assets/Images/error.svg';
import './TextField.css';

export const TextField = props => {
  const {
    text,
    textcolor,
    type,
    imageleft,
    imageRight,
    greentick,
    removeImageLeftBorder,
    borderColor,
    textLeft,
    handleRightButton,
    handleInput,
    name,
    error,
    value,
    placeholder,
    width,
    height,
    greentickWidth,
    className,
    required,
    handleClick,
    disabled = false,
    disabledStyle = false,
    labelClassName,
    handleMouseDown,
    handleMouseUp,
    handleMouseLeave,
    textArea,
    maxLength,
    autoComplete,
    textAreaPadding,
    onCopy,
    onPaste,
    onBlur,
    onFocus,
    customStyle,
    marginTextBottom,
    textAreaHeight,
    errorRecep,
    marginTextTop,
    isColorChange = false,
    placeholderStyles = true,
    textMarginLeft,
    textMarginRight,
    newType = ''
  } = props;
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (value !== inputValue) {
      setInputValue(value);
    }
  }, [value]);

  const handleInputChange = e => {
    let textValue = handleInput(type === 'checkbox' ? e.target.checked : e.target.value, e.target.name);
    if (textValue || textValue === '') {
      setInputValue(textValue);
    } else {
      if (newType === 'number') {
        const value = e.target.value;
        let cleanedValue = value.replace(/[^0-9]/g, '');
        setInputValue(cleanedValue);
      }
      if (newType === 'astrick') {
        const value = e.target.value;
        let cleanedValue = value.replace(/\*/g, ''); // Remove all asterisks
        setInputValue(cleanedValue);
      }
    }
  };

  return (
    //
    <div>
      {text ? (
        <div
          className={labelClassName}
          style={{
            marginTop: marginTextTop || 0,
            marginBottom: marginTextBottom || 2,
            color: textcolor ? textcolor : '#8E8E8E'
          }}
        >
          {text}
        </div>
      ) : null}

      <Stack
        direction='row'
        className={className}
        sx={{
          position: 'relative',
          width: width,
          height: height,
          alignItems: textArea ? 'flex-start' : 'center',
          borderRadius: '8px',
          ...(greentick && !error
            ? {
                borderRight: '1px solid #ECF0E5',
                borderTop: '1px solid #ECF0E5',
                borderBottom: '1px solid #ECF0E5'
              }
            : {
                ...(!error
                  ? {
                      border: `1px solid ${borderColor || '#8e8e8e'}`
                    }
                  : { border: '1px solid #E96666' })
              })
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            height: height || '40px',
            borderTopLeftRadius: 6,
            borderBottomLeftRadius: 6,
            ...(greentick ? { backgroundColor: '#b6d423' } : { backgroundColor: null })
          }}
        >
          {imageleft ? (
            <img
              style={{
                height: 24,
                margin: 12,
                width: 24
              }}
              alt='textfieldImage'
              src={imageleft}
            />
          ) : null}
          {textLeft ? (
            <div
              className='medium6'
              style={{
                // margin: 12,
                width: greentickWidth,
                color: '#21241E',
                textAlign: 'center',
                marginLeft: textMarginLeft,
                marginRight: textMarginRight
              }}
            >
              {textLeft}
            </div>
          ) : null}

          {removeImageLeftBorder ? null : (
            <div
              style={{
                borderRight: '2px solid #8e8e8e',
                height: 24,
                marginLeft: 2
              }}
            ></div>
          )}
        </div>
        <div style={{ display: 'flex', flex: 1 }}>
          <div style={{ width: '100%' }}>
            <FormControl sx={{ width: '100%' }}>
              {textArea ? (
                <textarea
                  className='medium6'
                  rows='4'
                  type={type}
                  value={inputValue}
                  name={name}
                  required={!!required}
                  onChange={handleInputChange}
                  style={{
                    alignItems: 'flex-start !important',
                    borderWidth: 0,
                    marginLeft: 2,
                    backgroundColor: 'transparent',
                    outlineWidth: 0,
                    outline: 'none',
                    padding: textAreaPadding || 12,
                    width: '100%',
                    color: error ? '#E96666' : disabled ? (isColorChange ? '#000000' : '#8e8e8e') : '#000000',
                    resize: 'none',
                    height: textAreaHeight
                  }}
                  placeholder={placeholder || text}
                  disabled={disabled}
                  maxLength={maxLength}
                />
              ) : (
                <input
                  onClick={handleClick}
                  className={`medium6 ${placeholderStyles ? 'custom-placeholder' : ''} `}
                  type={type}
                  value={inputValue}
                  name={name}
                  required={!!required}
                  onChange={handleInputChange}
                  style={{
                    borderWidth: 0,
                    height: 28,
                    marginLeft: 2,
                    backgroundColor: 'transparent',
                    outlineWidth: 0,
                    padding: 8,
                    width: '100%',
                    color: error ? '#E96666' : disabled ? (isColorChange ? '#000000' : '#8e8e8e') : '#000000',
                    outline: 'none',
                    ...customStyle
                  }}
                  maxLength={maxLength}
                  placeholder={placeholder || text}
                  disabled={disabled}
                  autoComplete={autoComplete}
                  onBlur={e => onBlur?.(e)}
                  onFocus={() => onFocus?.()}
                  onCopy={e => onCopy?.(e)}
                  onPaste={e => onPaste?.(e)}
                />
              )}
            </FormControl>

            {error ? (
              <div
                className='medium8'
                style={{
                  color: '#E96666',
                  position: 'absolute',
                  bottom: -16,
                  left: 0
                }}
              >
                {error}
              </div>
            ) : null}
          </div>

          {imageRight && text.includes('Password') ? (
            <ButtonBase
              style={{
                color: '#000',
                width: 24,
                height: 24,
                borderRadius: 12,
                marginRight: 8,
                cursor: 'pointer'
              }}
              variant='contained'
            >
              <img
                style={{
                  height: 24,
                  margin: 12,
                  width: 24
                }}
                alt='eye'
                src={imageRight}
                onClick={handleRightButton}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
              />
            </ButtonBase>
          ) : error ? (
            <img
              style={{
                height: 24,
                marginRight: 12,
                width: 24,
                alignSelf: 'center'
              }}
              alt='eye'
              src={errorImage}
            />
          ) : null}
        </div>
      </Stack>
      {errorRecep ? (
        <div
          className='medium8'
          style={{
            color: '#E96666',
            marginTop: '2px'
          }}
        >
          {errorRecep}
        </div>
      ) : null}
    </div>
  );
};
